module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6w5DC"))).then(() => parcelRequire('37nVf'));